import UsersActions from './Actions'
import { GridCellExpand } from './GridCellExpand'
import PropTypes from 'prop-types'

GridCellExpand.propTypes = {
  value: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
}

function renderCellExpand(params) {
  return <GridCellExpand value={params.value || ''} width={params.colDef.computedWidth} />
}

renderCellExpand.propTypes = {
  colDef: PropTypes.object.isRequired,
  value: PropTypes.string,
}

export const getColumns = (rowId, setRowId, workGroupOptions) => [
  {
    field: 'id',
    headerName: 'ID',
    headerAlign: 'center',
    width: 70,
    hide: false,
    filterable: false,
    renderCell: renderCellExpand,
  },
  {
    field: 'nombre',
    headerName: 'Nombre',
    headerAlign: 'center',
    flex: 2,
    minWidth: 85,
    editable: true,
  },
  {
    field: 'apellido',
    headerName: 'Apellido',
    headerAlign: 'center',
    flex: 2,
    minWidth: 90,
    editable: true,
  },
  {
    field: 'email',
    headerName: 'Email',
    headerAlign: 'center',
    flex: 2,
    minWidth: 150,
    editable: true,
  },
  {
    field: 'idGrupoMedicion',
    headerName: 'IDGrupoMedición',
    headerAlign: 'center',
    type: 'singleSelect',
    valueOptions: workGroupOptions,
    flex: 2,
    minWidth: 60,
    editable: true,
  },
  {
    field: 'habilitado',
    headerAlign: 'center',
    headerName: 'Habilitado',
    type: 'boolean',
    flex: 2,
    minWidth: 100,
    editable: true,
  },
  {
    field: 'idRol',
    headerName: 'Rol',
    filterable: false,
    headerAlign: 'center',
    flex: 2,
    minWidth: 100,
  },
  {
    field: 'actions',
    headerAlign: 'center',
    headerName: 'Acciones',
    type: 'actions',
    renderCell: params => <UsersActions {...{ params, rowId, setRowId }} />,
    minWidth: 100,
    flex: 1.2,
  },
]
